const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const UploadFiles = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UPLOAD _FILES_REQUEST":
      return { loading: true, error: false, data: [] };
    case "UPLOAD _FILES_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "UPLOAD _FILES_ERROR":
      return { loading: false, error: true, data: [] };
    case "UPLOAD _FILES_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default UploadFiles;
